<template>
  <el-form-item>
    <el-time-select
      v-bind="$attrs"
      v-model="startValue_"
      @input="updateValue"
      :placeholder="startTimePlaceholder"
      :picker-options="{
        start: minAvailableTime,
        step: timeStep,
        end: maxAvailableTime,
        maxTime: endValue_,
      }"
    />
    {{ connector }}
    <el-time-select
      v-bind="$attrs"
      v-model="endValue_"
      @input="updateValue"
      :placeholder="endTimePlaceholder"
      :picker-options="{
        start: minAvailableTime,
        step: timeStep,
        end: maxAvailableTime,
        minTime: startValue_,
      }"
    />
  </el-form-item>
</template>

<script>
export default {
  name: "DtTimeRange",
  props: {
    // 数组时间值绑定(v-model)
    value: {
      type: Array,
      default: () => [],
    },
    // 值类型,hourNumber为小时数,0-24
    valueType: { type: String, default: "string" },
    // 起始值绑定(sync)
    startValue: { default: null },
    // 结束值绑定(sync)
    endValue: { default: null },
    // 最可选时间
    minAvailableTime: { type: String, default: "00:00" },
    // 最可选时间
    maxAvailableTime: { type: String, default: "24:00" },
    // 时间步幅
    timeStep: { type: String, default: "01:00" },
    // 未填起始值的替代值
    startDefault: { default: null },
    // 未填结束值的替代值
    endDefault: { default: null },
    // 起始时间文案
    startTimePlaceholder: {
      type: String,
      default: "起始时间",
    },
    // 连接符文案
    connector: {
      type: String,
      default: "-",
    },
    // 结束时间文案
    endTimePlaceholder: {
      type: String,
      default: "结束时间",
    },
  },
  watch: {
    value(val) {
      this.syncValue(val);
    },
    startValue(val) {
      this.syncValue([val, this.endValue_]);
    },
    endValue(val) {
      this.syncValue([this.startValue_, val]);
    },
  },
  data() {
    return {
      startValue_: undefined,
      endValue_: undefined,
    };
  },
  methods: {
    syncValue(valueArr) {
      let [valueStart, valueEnd] = valueArr;
      if (this.valueType === "hourNumber") {
        valueStart = typeof valueStart === "number" && `${(valueStart + "").padStart(2, "0")}:00`;
        valueEnd = typeof valueEnd === "number" && `${(valueEnd + "").padStart(2, "0")}:00`;
      }
      this.startValue_ = valueStart;
      this.endValue_ = valueEnd;
    },
    updateValue() {
      let valueStart = this.startValue_ || this.startDefault,
        valueEnd = this.endValue_ || this.endDefault;
      if (this.valueType === "hourNumber") {
        valueStart = valueStart && valueStart.substr(0, 2) * 1;
        valueEnd = valueEnd && valueEnd.substr(0, 2) * 1;
      }
      this.$emit("input", [valueStart, valueEnd]);
      this.$emit("change", [valueStart, valueEnd]);
      this.$emit("update:startValue", valueStart);
      this.$emit("update:endValue", valueEnd);
    },
  },
};
</script>
